<template>
  <tr 
    class="no-result-wrap"
    :style="height ? `height: ${height}`  : 'height: 50vh'"
  >
    <td :colspan="`${colspan}`">
      <div class="d-flex justify-content-center align-items-center" style="flex-direction: column">
        <i v-if="!noIcon" class="fa-solid fa-triangle-exclamation" />
        <p>
          {{ message ? message : $t('common_no_result') }}
        </p>
      </div>
    </td>
  </tr>
</template>
<script>
export default {
    name: 'NoResult',
    props: {
      colspan: {
        type: Number,
        required: true,
      },
      message: {
        type: String,
      },
      height: {
        type: String,
      },
      noIcon: {
        type: Boolean,
        default: false,
      }
    }
}
</script>
<style scoped>

td {
  padding: 48px 16px 56px 16px;
}

i {
  background-color: transparent;
  font-size: 1.5rem;
  color: #acb2b9;
  line-height: 1;
}

p {
  margin-top: 10px;
  font-weight: 400;
  color: #acb2b9;
  font-size: 16px;
  line-height: 1;
}
</style>